module.exports = __webpack_public_path__ + "assets/img/hov_btn_AppStore-65743d56.png";